// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3wM_2","productName":"Table_productName__2mPYj"};